'use client';

import React, { useState, useEffect } from 'react';
import StickyAnchorNav from '@/components/common/StickyAnchorNav';
import FloatingCTA from '@/components/common/FloatingCTA';
import HeroSection from './HeroSection';
import BenefitsSection from './BenefitsSection';
import HowItWorksSection from './HowItWorksSection';
import ProfileSection from './ProfileSection';
import CommissionSection from './CommissionSection';
import TestimonialsSection from './TestimonialsSection';
import GlobalCommunitySection from './GlobalCommunitySection';
import FinalCTASection from './FinalCTASection';
import FAQSection from './FAQSection';

const LandingPageInteractive = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 80;
      const pos = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: pos, behavior: 'smooth' });
    }
  };

  const handleApplyClick = () => scrollToSection('aplicar');
  const handleLearnMoreClick = () => scrollToSection('beneficios');

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <StickyAnchorNav
        isOpen={isNavOpen}
        onToggle={() => setIsNavOpen(!isNavOpen)}
      />

      <main>
        {/* Hero */}
        <HeroSection
          onApplyClick={handleApplyClick}
          onWatchStoriesClick={handleLearnMoreClick}
        />

        {/* Benefits */}
        <BenefitsSection />

        {/* How It Works */}
        <HowItWorksSection />

        {/* Personal Profile */}
        <ProfileSection />

        {/* Commission Plan */}
        <CommissionSection />

        {/* Testimonials */}
        <TestimonialsSection />

        {/* Global Community */}
        <GlobalCommunitySection />

        {/* FAQ */}
        <div id="preguntas" className="bg-white">
          <FAQSection />
        </div>

        {/* Final CTA */}
        <FinalCTASection onApplyClick={handleApplyClick} />
      </main>

      {/* Footer */}
      <footer className="bg-[#0A1628] py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-xl bg-white/10 flex items-center justify-center">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 1L10 6H15L11 9.5L12.5 14.5L8 11.5L3.5 14.5L5 9.5L1 6H6L8 1Z" fill="#C9A84C" />
                </svg>
              </div>
              <span className="font-display font-bold text-white">Neuroakashic™</span>
            </div>
            <p className="text-white/40 text-sm font-body text-center">
              © {new Date().getFullYear()} Neuroakashic™. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="mailto:info@anasilvialara.com" className="text-white/40 hover:text-white/70 text-sm font-body transition-colors">
                info@anasilvialara.com
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating CTA */}
      <FloatingCTA
        onApplicationClick={handleApplyClick}
        onChatClick={() => window.open('https://wa.link/anasilvialara', '_blank')}
      />
    </div>
  );
};

export default LandingPageInteractive;